module.exports = __webpack_public_path__ + "bg2.a2f5c66163ae8598c4ea.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/USer/Interviewfeedback/src/app/header/img/bg2.png
// module id = ../../../../../src/app/header/img/bg2.png
// module chunks = main